import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import AtpAvailableState from "@sonic/Store/Components/AvailableToPromise/AvailableToPromiseState";
import { Draft } from "immer";

const initialState: AtpAvailableState = {
    isDisabledButton: false,
};

const reducer = {
    "Pages/CheckoutReviewAndSubmit/ToggleAvailableToPromise": (
        draft: Draft<AtpAvailableState>,
        action: { parameter: AtpAvailableState },
    ) => {
        draft.isDisabledButton = false; // action.parameter.isDisabledButton;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
